import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';

/**
 * Wrapper um den `AutoLoginPartialRoutesGuard` der angular-auth-oidc-client.
 *
 * Der Library-Guard reicht das KOMPLETTE `route.data`-Objekt als OIDC-customParams
 * an den Authorize-/Login-Request weiter (siehe dessen `canActivate`). Wir nutzen
 * `route.data` aber ausschliesslich fuer App-Metadaten (breadcrumb, roles,
 * permissions), nicht als Identity-Provider-Parameter. Das fuehrt zu zwei Problemen:
 *   1. Absturz: `data: { breadcrumb: null }` -> die Lib ruft beim Bauen der
 *      Authorize-URL `value.toString()` auf jedem data-Wert auf -> `null.toString()`
 *      -> "TypeError: Cannot read properties of null (reading 'toString')".
 *   2. Leak: roles/permissions/breadcrumb landen als Query-Parameter in der
 *      Authorize-URL zum IdP.
 *
 * Der Crash trat beim Logout auf: `logoffAndRevokeTokens()` setzt die Auth-Daten
 * zurueck, woraufhin der Guard der aktuellen Route erneut laeuft, nicht mehr
 * authentifiziert ist und einen frischen Authorize-Flow mit `route.data` startet.
 *
 * Deshalb delegieren wir an den Library-Guard mit geleertem `route.data`.
 */
export const autoLoginGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const guard = inject(AutoLoginPartialRoutesGuard);
  const sanitizedRoute = { ...route, data: {} } as ActivatedRouteSnapshot;
  return guard.canActivate(sanitizedRoute, state);
};
